export default __webpack_public_path__ + "static/media/equilibrio-04.ea62361f.jpg";